// updating some bootstrap JS behavior

bq.global.bootstrapFixes = function() {
  //stop dropdowns from closing when trying to use form elements
  $('.dropdown-menu input, .dropdown-menu select, .dropdown-menu textarea').each(function() {
    var $this = $(this);
    if($this.data('hasBSFix') !== true) { //prevent it from adding click event multiple times
      $this.data('hasBSFix', true);
      $(this).on('click', function(e) {
          e.stopPropagation(); //This will prevent the event from bubbling up and close the dropdown when you type/click on text boxes.
      });
    }
  });

  //Fix for filter bar dropdown toggling
  $('.filter-bar-dropdown').on('shown.bs.collapse', function(){
    $('.filter-bar-dropdown:visible').not(this).collapse('hide');
  });

  $('.filter-bar-dropdown').on('click', '.actions .buttons-set-a .btn', function(){
    $('.filter-bar-filters a').click();
  });

  $('.grid-filter-container').on('click', '.list-tags .label-remove', function() {
    $('.filter-bar-filters a:not(.collapsed)').click();
  });

  $('[data-bq="collapse"]').each(function() {
    var $this = $(this);
    if($this.data('hasBSFix') !== true) { //prevent it from adding click event multiple times
      $this.data('hasBSFix', true);
      $this.on('click', function(e) {

        var $$this = $(this);
        var $collapse = $$this.closest('.collapse-group').find('.collapse');

        if($collapse.length >= 1) {
          $$this.toggleClass('collapsed-bq');

          var open = $$this.data('open');
          var closed = $$this.data('closed');

          if(open && closed) {
            if( $('html').hasClass('ie9') ) {

              // IE9 personal collapse logic
              if( !$$this.data('collapse-ie') ) {
                $$this.html(open);
                $collapse.collapse('hide');
                $$this.data('collapse-ie', true)
              } else {
                $$this.html(closed);
                $collapse.collapse('show');
                $$this.data('collapse-ie', false)
              }
            } else {

              // other browsers
              if($$this.hasClass('collapsed-bq')) {
                $$this.html(closed);
                $collapse.collapse('hide');
              } else {
                $$this.html(open);
                $collapse.collapse('show');
              }
            }
          }
        }

        if($$this.find('em, span').is('[class*="fa-angle"]')) {
          $(this).find('em, span').toggleClass('fa-angle-down');
          $(this).find('em, span').toggleClass('fa-angle-up');
        }
        e.preventDefault();
      });
    }
  });

  $('[data-bq="collapse-all"]').each(function() { //toggle all collapsable elements, uses data-target to denote parent element
    var $this = $(this);
    $this.on('click', function(){
      var $$this = $(this);

      $('[data-bq="collapse"]', $$this.data('target')).click();
    });
  });

  $('[data-bq="mobile-footer-collapse"]').each(function() {
    var $this = $(this);
    $this.on('click', function(){
      var $$this = $(this);
      var open = $$this.data('open');
      var closed = $$this.data('closed');

      if(open && closed) {
        if($$this.hasClass('collapsed-bq')) {
          $$this.html(closed);
          $('[data-bq="collapse"]').each(function(){
            if(!$(this).hasClass('collapsed-bq')) {
              $(this, $$this.data('target')).click();
            }
          });
        } else {
          $$this.html(open);
        }
      }
      $$this.toggleClass('collapsed-bq');
    });
  });

  //
  $('.modal:not( .content-curation-modal , .supplier-payment-request-modal )').each(function() {
    //move all modals to under body tag
    $(this).appendTo("body");
  });


  try {
    //help with conflicts that are caused by prototype
    if (window.jQuery) {

      if (Prototype.BrowserFeatures.ElementExtensions) {
          var disablePrototypeJS = function (method, pluginsToDisable) {
                  var handler = function (event) {
                      event.target[method] = undefined;
                      setTimeout(function () {
                          delete event.target[method];
                      }, 0);
                  };
                  pluginsToDisable.each(function (plugin) {
                      jQuery(window).on(method + '.bs.' + plugin, handler);
                  });
              },
              pluginsToDisable = ['collapse', 'dropdown', 'modal', 'tooltip'];
          disablePrototypeJS('show', pluginsToDisable);
          disablePrototypeJS('hide', pluginsToDisable);
      }
    }

  } catch(ex) {}

  //If dropup is too tall and goes off the screen
  $('.dropdown.dropup').on('show.bs.dropdown', function(e) {
    var button = $(this).find('[data-toggle="dropdown"]'),
        posOfButton = button.offset().top,
        heightOfMenu = $(this).find('.dropdown-menu').height();

    var validate = button.data('validate');
    if (validate && $(validate).parsley()) {
      if (!$(validate).parsley().validate()) {
        e.stopPropagation();
        e.preventDefault();
      }
    }

    if(heightOfMenu > posOfButton) {
      $(this).find('.dropdown-menu').css({
        'height': posOfButton,
        'zIndex': 9999,
        'overflowY': 'scroll'
      });
    }
  });

  //end prototype confict fix
  jQuery('span[data-bq="collapse"]').unbind().on('click', function(){
    if((jQuery(this).hasClass('fa-angle-double-up')) ? jQuery(this).removeClass('fa-angle-double-up').addClass('fa-angle-double-down') : jQuery(this).removeClass('fa-angle-double-down').addClass('fa-angle-double-up'));
  });

  // fox bootstrap nav-menu collapse
  $(document).on('hide.bs.collapse', '#nav-level-one .nav-level-three', function(){
    $(this).closest('li').find('[data-toggle="collapse"]').addClass('collapsed');
  });
};


bq.init.push(bq.global.bootstrapFixes);
